var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableau(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.3 59.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 40.2h3.3v-9h8.3V28h-8.3v-9h-3.3v9h-8.2v3.2h8.2z",
    fill: "#e8762d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 53.2H16v-8h7.4v-2.5H16v-8.1h-2.8v8.1H5.8v2.5h7.4z",
    fill: "#c72037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 24.3h2.8v-8h7.5v-2.4h-7.5V5.8h-2.8v8.1h-7.4v2.4h7.4z",
    fill: "#5b879b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59.5h2.4v-5.7h5.1v-2.1h-5.1V46H29v5.7h-5v2.1h5z",
    fill: "#5c6692"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 24.3h2.6v-8.1h7.5v-2.3h-7.5V5.8h-2.6v8.1H5.8v2.3h7.5z",
    fill: "#eb9129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 36.3h2.4v-5.6h5.1v-2.2h-5.1v-5.6h-2.4v5.6h-5v2.2h5z",
    fill: "#5c6692"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M44.3 53.2h2.8v-8h7.5v-2.5h-7.5v-8.1h-2.8v8.1h-7.4v2.5h7.4z",
    fill: "#1f457e",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 7.2V5.5h-5V0h-1.8v5.5h-5v1.7h5v5.5h1.8V7.2zM5 35.9h1.8v-5.5h5v-1.7h-5v-5.4H5v5.4H0v1.8l5-.1z",
    fill: "#7199a6"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0NjciIHdpZHRoPSIyNTAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MC4zIDU5LjUiPjxwYXRoIGQ9Ik0yOC41IDQwLjJoMy4zdi05aDguM1YyOGgtOC4zdi05aC0zLjN2OWgtOC4ydjMuMmg4LjJ6IiBmaWxsPSIjZTg3NjJkIi8+PHBhdGggZD0iTTEzLjIgNTMuMkgxNnYtOGg3LjR2LTIuNUgxNnYtOC4xaC0yLjh2OC4xSDUuOHYyLjVoNy40eiIgZmlsbD0iI2M3MjAzNyIvPjxwYXRoIGQ9Ik00NC4zIDI0LjNoMi44di04aDcuNXYtMi40aC03LjVWNS44aC0yLjh2OC4xaC03LjR2Mi40aDcuNHoiIGZpbGw9IiM1Yjg3OWIiLz48cGF0aCBkPSJNMjkgNTkuNWgyLjR2LTUuN2g1LjF2LTIuMWgtNS4xVjQ2SDI5djUuN2gtNXYyLjFoNXoiIGZpbGw9IiM1YzY2OTIiLz48cGF0aCBkPSJNMTMuMyAyNC4zaDIuNnYtOC4xaDcuNXYtMi4zaC03LjVWNS44aC0yLjZ2OC4xSDUuOHYyLjNoNy41eiIgZmlsbD0iI2ViOTEyOSIvPjxwYXRoIGQ9Ik01Mi44IDM2LjNoMi40di01LjZoNS4xdi0yLjJoLTUuMXYtNS42aC0yLjR2NS42aC01djIuMmg1eiIgZmlsbD0iIzVjNjY5MiIvPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQ0LjMgNTMuMmgyLjh2LThoNy41di0yLjVoLTcuNXYtOC4xaC0yLjh2OC4xaC03LjR2Mi41aDcuNHoiIGZpbGw9IiMxZjQ1N2UiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0zNi4xIDcuMlY1LjVoLTVWMGgtMS44djUuNWgtNXYxLjdoNXY1LjVoMS44VjcuMnpNNSAzNS45aDEuOHYtNS41aDV2LTEuN2gtNXYtNS40SDV2NS40SDB2MS44bDUtLjF6IiBmaWxsPSIjNzE5OWE2Ii8+PC9zdmc+";
export { SvgTableau as ReactComponent };